import * as constants from './constants';

const initialState = {
  activity: { sharedMM: [] },
  connections: { request: [] },
  contracting: { newMessage: [], updates: [] },
  workspaceNotifications: { message: [], bulkmessage: [] },
  weekly: {},
  email: '',
  unsubscribeAllChecked: false,
  showUnsubscribeFeedback: false,
  unsubscribeRadioSelected: '',
  unsubscribeReason: '',
  showThankYouForFeedback: false,

  // loaders
  loadingNotifications: false,
  savingNotifications: false,
  savingUnsubscribeReason: false,
};

export function publicNotifications(state = initialState, { type, payload }) {
  switch (type) {
    case constants.UPDATE_PUBLIC_NOTIFICATION_PROP:
      return { ...state, ...payload };
    case constants.GET_PS_STARTING:
      return { ...state, loadingNotifications: true };
    case constants.GET_PS_FINISHED:
      return { ...state, ...payload, loadingNotifications: false };
    case constants.GET_PS_FAILED:
      return { ...state, loadingNotifications: false };
    case constants.EDIT_NOTI_STARTING:
      return { ...state, savingNotifications: true };
    case constants.EDIT_NOTI_FINISHED:
      return {
        ...state,
        ...payload,
        showUnsubscribeFeedback: state.unsubscribeAllChecked,
        savingNotifications: false,
      };
    case constants.EDIT_NOTI_FAILED:
      return { ...state, savingNotifications: false };
    case constants.SUBMIT_UNSUBSCRIBE_STARTING:
      return { ...state, savingUnsubscribeReason: false };
    case constants.SUBMIT_UNSUBSCRIBE_FINISHED:
      return {
        ...state,
        savingUnsubscribeReason: false,
        showUnsubscribeFeedback: false,
        showThankYouForFeedback: false,
      };
    case constants.SUBMIT_UNSUBSCRIBE_FAILED:
      return {
        ...state,
        savingUnsubscribeReason: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/settings/public/reducer.js